<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Macchine </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_calendario_generico = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-calendar </v-icon>
          </v-btn>
        </template>
        <span>Vedi calendario generico</span>
      </v-tooltip>
      <!-- Bottone di salvataggio -->
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="creaCalendario"
            small
            v-bind="attrs"
            v-on="on"
            class="ml-5"
          >
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Crea calendario schedulazione</span>
      </v-tooltip> -->
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-row align="center" justify="center">
        <v-col cols="3">
          <v-autocomplete
            background-color="#ffffff"
            @change="filtra()"
            hide-details
            :items="macchine_lista"
            :item-text="(e) => e.des_macchina"
            item-value="des"
            label="Nome"
            style="display: inline-block; max-width: 350px"
            v-model="nome"
          >
            <template v-slot:append>
              <v-icon
                class="ml-2"
                @click="
                  nome = '';
                  filtra();
                "
                color="primary"
                >{{ nome == "" ? "mdi-filter" : "mdi-filter-off" }}</v-icon
              >
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-autocomplete
            background-color="#ffffff"
            @change="filtra()"
            hide-details
            :items="tipi_lista"
            :item-text="(e) => e.des"
            item-value="id_tipo"
            label="Tipo"
            style="display: inline-block; max-width: 350px"
            v-model="tipo_selez"
          >
            <template v-slot:append>
              <v-icon
                class="ml-2"
                @click="
                  tipo_selez = '';
                  filtra();
                "
                color="primary"
                >{{ tipo_selez == "" ? "mdi-filter" : "mdi-filter-off" }}</v-icon
              >
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-autocomplete
            background-color="#ffffff"
            @change="filtra()"
            hide-details
            :items="reparti_lista"
            :item-text="(e) => e.des"
            item-value="id_reparto"
            label="Reparto"
            style="display: inline-block; max-width: 350px"
            v-model="reparto_selez"
          >
            <template v-slot:append>
              <v-icon
                class="ml-2"
                @click="
                  reparto_selez = '';
                  filtra();
                "
                color="primary"
                >{{ reparto_selez == "" ? "mdi-filter" : "mdi-filter-off" }}</v-icon
              >
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-autocomplete
            background-color="#ffffff"
            @change="filtra()"
            hide-details
            :items="sedi_lista"
            :item-text="(e) => e.des"
            item-value="id_sede"
            label="Sede"
            style="display: inline-block; max-width: 350px"
            v-model="sede_selez"
          >
            <template v-slot:append>
              <v-icon
                class="ml-2"
                @click="
                  sede_selez = '';
                  filtra();
                "
                color="primary"
                >{{ sede_selez == "" ? "mdi-filter" : "mdi-filter-off" }}</v-icon
              >
            </template>
          </v-autocomplete>
        </v-col>
        </v-row
      >
      <v-data-table
        height="60vh"
        :headers="headers_macchine"
        :items="lista_vista"
        fixed-header
        :key="aggiorna"
        class="elevation-1 pt-0"
      >
        <!-- Colonna del calendario specifico -->
        <template v-slot:[`item.cal_spec`]="{ item }">
          <v-btn
            @click="
              dialog_calendario_specifico = true;
              macchina_sel_id = item.id_macchina;
              tipo = 3;
              macchine.push(macchina_sel_id);
            "
            small
            ><v-icon :color="item.eccezione ? 'orange' : 'primary'"
              >mdi-calendar-star</v-icon
            ></v-btn
          >
        </template>
        <template v-slot:[`item.reparto`]="{ item }">
          <span> 
          <v-btn
          v-if="item.id_reparto"
            @click="
              dialog_calendario_specifico = true;
              macchina_sel_id = item.id_reparto;
              tipo = 2;
              macchine.push(macchina_sel_id);
            "
            small
            ><v-icon  :color="item.eccezione ? 'orange' : 'primary'"
              >mdi-calendar-star</v-icon
            ></v-btn
          >{{ item.des_reparto }}</span>
        </template>
        <template v-slot:[`item.sede`]="{ item }">
          <span> 
          <v-btn
          v-if="item.id_sede" 
            @click="
              dialog_calendario_specifico = true;
              macchina_sel_id = item.id_sede;
              tipo = 1;
              macchine.push(macchina_sel_id);
            "
            small
            ><v-icon :color="item.eccezione ? 'orange' : 'primary'"
              >mdi-calendar-star</v-icon
            ></v-btn
          >{{ item.des_sede }}</span>
        </template>
        <!-- Colonna della generazione calendario -->
        <template v-slot:[`item.cal_gen`]="{ item }">
          <v-btn @click="generaCalendario(item)" small
            ><v-icon :color="item.disponibilita ? 'primary' : 'orange'"
              >mdi-calendar-plus</v-icon
            ></v-btn
          >
        </template>
      </v-data-table>
    </v-card-text>
    <!-- DIALOG CALENDARIO GENERICO -->
    <v-dialog v-model="dialog_calendario_generico" max-width="600px">
      <CalendarioGenerico
        @click_chiudi="dialog_calendario_generico = false"
        :bottoni="true"
      />
    </v-dialog>
    <!-- DIALOG CALENDARIO SPECIFICO -->
    <v-dialog v-model="dialog_calendario_specifico" max-width="800px">
      <CalendarioSpecifico
        @click_chiudi="
          dialog_calendario_specifico = false;
          macchina_sel_id = null;
          tipo = null;
          getEccezioniLista();
        "
        :id_riferimento="macchina_sel_id"
        :tipo="tipo"
      />
    </v-dialog>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import CalendarioGenerico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioGenerico.vue";
import CalendarioSpecifico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioSpecifico.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";


export default {
  name: "",

  components: { CalendarioGenerico, CalendarioSpecifico, SnackbarQV },

  props: [],

  data() {
    return {
      // Variabili d'appoggio
      macchina_sel_id: null,
      nome: "",
      aggiorna: 0,
      tipo: null,
      sede_selez: "",
      reparto_selez: "",
      tipo_selez: "",
      // Modal
      dialog_calendario_generico: false,
      dialog_calendario_specifico: false,
      // Array
      headers_macchine: new Array(),
      macchine_lista: new Array(),
      lista_vista: new Array(),
      lista_eccezioni: new Array(),
      lista_disponibilita: new Array(),
      macchine: new Array(),
      sedi_lista: [],
      reparti_lista: [],
      tipi_lista: [],
    };
  },

  computed: {},

  watch: {
    macchine_lista: {
      immediate: true,
      handler() {
        this.lista_vista = this.macchine_lista;
        this.filtra();
      },
    },
  },

  methods: {
    filtra() {
      console.log("filtra");

      let items_wo_tmp = [];
      this.macchine_lista.forEach((elem) => {
        items_wo_tmp.push(elem);
      });

      // Filtro il nome
      if (this.nome != "") {
        let res = [];

        items_wo_tmp.forEach((elem) => {
          if (elem.des_macchina == this.nome) {
            res.push(elem);
          }
        });

        items_wo_tmp = res;
      }

      // Filtro il tipo
      if (this.tipo_selez != "") {
        let res = [];

        items_wo_tmp.forEach((elem) => {
          if (elem.id_tipo_get_macchina == this.tipo_selez) {
            res.push(elem);
          }
        });

        items_wo_tmp = res;
      }

      // Filtro la sede
      if (this.sede_selez != "") {
        let res = [];

        items_wo_tmp.forEach((elem) => {
          if (elem.id_sede == this.sede_selez) {
            res.push(elem);
          }
        });

        items_wo_tmp = res;
      }

      // Filtro il reparto
      if (this.reparto_selez != "") {
        let res = [];

        items_wo_tmp.forEach((elem) => {
          if (elem.id_reparto == this.reparto_selez) {
            res.push(elem);
          }
        });

        items_wo_tmp = res;
      }

      this.lista_vista = [];
      this.lista_vista = items_wo_tmp;
    },

    generaCalendario(item) {
      let request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "salvacalendariomacchine",
          token: localStorage.getItem("user_token"),
          macchine: [{ id_macchina: item.id_macchina }],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getListaMacchine();
            this.$refs.SnackbarQV.print("success", "Salvataggio Effettuato.");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },

    getListaMacchine() {
      this.headers_macchine = [
        {
          text: "Calendario specifico",
          value: "cal_spec",
        },
        //{
          //text: "Genera calendario",
          //value: "cal_gen",
        //},
        {
          text: "Sede",
          value: "sede",
        }, 
        {
          text: "Reparto",
          value: "reparto",
        }, 
        {
          text: "Codice",
          value: "cod_macchina",
        },
        {
          text: "Nome",
          value: "des_macchina",
        },
        {
          text: "Tipo",
          value: "des_tipo",
        }, 
        /* {
          text: "Specifiche",
          value: "specifiche",
        }, */
      ];

      const getlistamacchine = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", getlistamacchine).then((res) => {
        if (res.status === 200) {
          this.macchine_lista = [];
          this.reparti_lista = [];
          this.sedi_lista = [];
          this.tipi_lista= [];

          res.data.macchine.forEach((e) => {
            this.macchine_lista.push(e);
            if(this.reparti_lista.filter((m) => m.id_reparto == e.id_reparto).length == 0 && e.id_reparto!= null) {
              this.reparti_lista.push({
                id_reparto : e.id_reparto,
                des : e.des_reparto,
              });
            }

            if(this.sedi_lista.filter((m) => m.id_sede == e.id_sede).length == 0 && e.id_sede!= null) {
              this.sedi_lista.push({
                id_sede : e.id_sede,
                des : e.des_sede,
              });
              console.log(e.des_sede);
            }

            if(this.tipi_lista.filter((m) => m.id_tipo == e.id_tipo_get_macchina).length == 0 && e.id_tipo_get_macchina!= null) {
              this.tipi_lista.push({
                id_tipo : e.id_tipo_get_macchina,
                des : e.des_tipo,
              });
            }
          });
          
          this.getEccezioniLista();
          this.getDisponibilitaLista();
          console.log(this.macchine_lista);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },

    /* creaCalendario() {
      this.macchine = this.macchine.toString();
      console.log(this.macchine);

      let request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "salvacalendariomacchine",
          token: localStorage.getItem("user_token"),
          macchine: this.macchine,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.macchine = [];
            this.$refs.SnackbarQV.print("success", "Salvataggio Effettuato.");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    }, */

    getEccezioniLista() {
      let request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "geteccezionilista",
          token: localStorage.getItem("user_token"),
          tipo: 3,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.lista_eccezioni = res.data.calendario_ecc
            ? res.data.calendario_ecc
            : [];
          this.macchine_lista.forEach((macchina) => {
            macchina.eccezione = false;
            this.lista_eccezioni.forEach((ecc) => {
              if (macchina.id_macchina == ecc.rif_calendario) {
                macchina.eccezione = true;
              }
            });
          });

          this.aggiorna = this.aggiorna == 1 ? 0 : 1;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
      });
    },

    getDisponibilitaLista() {
      let request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "getdisponibilitamacchina",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.lista_disponibilita = res.data ? res.data : [];
          console.log(this.lista_disponibilita);
          console.log(this.macchine_lista);
          this.macchine_lista.forEach((v) => {
            v.disponibilita = true;
            this.lista_disponibilita.forEach((ecc) => {
              if (v.id_macchina == ecc.id_macchina) {
                v.disponibilita = false;
              }
            });
          });

          this.aggiorna = this.aggiorna == 1 ? 0 : 1;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
      });
    },

    
  },

  created() {},

  mounted() {
    this.getListaMacchine();
  },
};
</script>

<style scoped>
</style>